import { isMobile } from '../helpers/isMobile';

// RU: id строки — индекс в InitialState.oddsInfo сервера: коэффициенты пейтейбла ядро берёт
//     с сервера (решение владельца 05.10); у сервера строка на каждый символ (8), стенд держал 5 схлопнутых строк — id 3 → 4, 4 → 6.
export const oddsInfoEnumsByGame = {
  174: {
    oddsInfoEnumWeb: [
      { id: 0, oddX: -25, oddContainerY: 20, oddsContainerX: 290, oddsContainerY: 340 },
      { id: 1, oddX: -25, oddContainerY: 20, oddsContainerX: 1020, oddsContainerY: 340 },
      { id: 2, oddX: -25, oddContainerY: 20, oddsContainerX: 330, oddsContainerY: 580 },
      { id: 4, oddX: -25, oddContainerY: 20, oddsContainerX: 645, oddsContainerY: 580 },
      { id: 6, oddX: -25, oddContainerY: 20, oddsContainerX: 975, oddsContainerY: 580 },
    ],
    oddsInfoEnumMobile: [
      { id: 0, oddX: 12, oddContainerY: 15, oddsContainerX: 100, oddsContainerY: 720 },
      { id: 1, oddX: 12, oddContainerY: 15, oddsContainerX: 355, oddsContainerY: 720 },
      { id: 2, oddX: 12, oddContainerY: 15, oddsContainerX: 95, oddsContainerY: 935 },
      { id: 4, oddX: 12, oddContainerY: 15, oddsContainerX: 355, oddsContainerY: 935 },
      { id: 6, oddX: 12, oddContainerY: 15, oddsContainerX: 230, oddsContainerY: 1150 },
    ],
  },
};

export const payTableStepsContentByGame = {
  174: {
    step0: {
      id: 0,
      isHide: false,
      text: 'SYMBOL_PAYOUT',
      contentImage: 'payTableStep0Image',
      stepInfoText: [
        {
          x: isMobile() ? 150 : 473,
          y: isMobile() ? 450 : 346,
          type: 'middleText',
          align: 'center',
          wordWrapWidth: isMobile() ? 260 : 450,
          text: 'SYMBOL_PAYOUT_1',
        },
      ],
      y: 120,
    },
    step1: {
      id: 1,
      isHide: false,
      text: 'WINNING_LINES',
      contentImage: 'payTableStep1Image',
      stepInfoText: [
        {
          x: isMobile() ? 270 : 2160,
          y: isMobile() ? 1675 : 675,
          anchor: 0.5,
          type: 'text',
          align: 'center',
          wordWrapWidth: isMobile() ? 394 : 687,
          text: 'WINNING_LINES_TEXT',
        },
      ],
      y: 1235,
    },
    step2: {
      id: 2,
      isHide: false,
      text: 'WILDS_TITLE',
      contentImage: 'payTableStep2Image',
      stepInfoText: [
        {
          x: isMobile() ? 270 : 3600,
          y: isMobile() ? 2110 : 675,
          anchor: 0.5,
          type: 'text',
          align: 'center',
          wordWrapWidth: isMobile() ? 394 : 687,
          text: 'WILDS_TEXT',
        },
      ],
      y: isMobile() && 1705,
    },
    step3: {
      id: 3,
      isHide: true,
      text: 'JACKPOT',
      contentImage: 'payTableStep3Image',
      stepInfoText: [
        {
          x: isMobile() ? 270 : 5040,
          y: isMobile() ? 2535 : 675,
          anchor: 0.5,
          type: 'text',
          align: 'center',
          wordWrapWidth: isMobile() ? 394 : 687,
          text: 'JACKPOT_INTRO',
        },
      ],
      y: isMobile() && 2140,
    },
  },
};
